import React, { useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import ComplimentryOrderwise from "../component/ComplimentryOrderwise";
import ComplimentryAll from "../component/ComplimentryAll";
import ComplimentryGroupItem from "../component/ComplimentryGroupItem";

const ComplimentryLogs = () => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Complimentry Logs" pageTitle="Complimentry Logs" />
      </div>
      <div>
        {/* Navigation */}
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => toggle("1")}
              style={{ cursor: "pointer" }}
            >
              Complimentry Logs
            </NavLink>
          </NavItem>
          {/* <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => toggle("2")}
              style={{ cursor: "pointer" }}
            >
              Orderwise
            </NavLink>
          </NavItem> */}
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => toggle("2")}
              style={{ cursor: "pointer" }}
            >
              Group by items
            </NavLink>
          </NavItem>
        </Nav>

        {/* Tab Content */}
        <TabContent activeTab={activeTab} className="p-3 border border-top-0">
          <TabPane tabId="1">
            <ComplimentryAll />
          </TabPane>
          {/* <TabPane tabId="2">
            <ComplimentryOrderwise />
          </TabPane> */}
          <TabPane tabId="2">
            <ComplimentryGroupItem />
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default ComplimentryLogs;
